<template>
	<div>
		<span>
			{{ this.realContent }}
		</span>
	</div>
</template>
<script>

import {enumDef} from "@/common/enumDefs";

export default {
	computed: {
		realContent() {
			let ratingStatus = this.params.data[this.params.ratingStatusField];
			let rating = this.params.data[this.params.colDef.field];

			return enumDef.ratingStatus.isRatingStatusActive(ratingStatus) && rating ? rating : "";
		}
	}
};
</script>
